module.exports = __webpack_public_path__ + "static/media/team-icon2.4c22433f.svg";